import { useMemo, useState } from 'react';

function formatDate(date: Date) {
    return date.toISOString().slice(0, 10);
}

export function useDashboardV3Range<T extends string>(defaultRange: T) {
    const [range, setRange] = useState<T>(defaultRange);
    const [customFrom, setCustomFrom] = useState(() =>
        formatDate(new Date(Date.now() - 7 * 86400000))
    );
    const [customTo, setCustomTo] = useState(() => formatDate(new Date()));

    const rangeParams = useMemo(
        () => ({
            range,
            startDate: range === 'custom' ? customFrom : undefined,
            endDate: range === 'custom' ? customTo : undefined,
        }),
        [range, customFrom, customTo]
    );

    return {
        range,
        setRange,
        customFrom,
        setCustomFrom,
        customTo,
        setCustomTo,
        rangeParams,
    };
}